import { FeaturedPromotionPage } from '@/features/shop/components/FeaturedPromotionContainer'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { withHeaderLayout } from '@/features/shared/components/Headers/Layouts/HeaderLayout'
import { inferZipAndStoreForSlugifiedRoute } from '@/features/shared/serverUtils/inferZipAndStoreForSlugifiedRoute'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.RETAILER_FEATURED_PROMOTIONS,
  inferZipAndStoreForSlugifiedRoute,
)

export default withHeaderLayout(FeaturedPromotionPage)
